import React, { Component } from 'react'
import { Typeahead } from 'react-bootstrap-typeahead'
import { injectIntl } from 'react-intl'
import messages from './messages'

import RegionTools from 'utils/regions/regionTools'

class TypeAheadFilter extends Component {
  constructor(props) {
    super(props)

    const {
      intl: { formatMessage }
    } = props
    this.formatMessage = formatMessage

    this.state = {
      selected: [],
      regionsDataByCountry: RegionTools.getRegionsDataByCountry(this.props.regionsData)
    }
    this.typeAhead = React.createRef()
  }

  componentDidUpdate() {
    const selectedElements = document.querySelectorAll('.rbt-token-removeable')
    if (selectedElements.length) {
      for (let i = 0; i < selectedElements.length; i++) {
        const removeItemOnClick = e => {
          if (e.target === selectedElements[i]) {
            let name = selectedElements[i].innerHTML.split('<')[0]
            let newSelected = this.state.selected.filter(selectedItem => `${selectedItem.name} (${selectedItem.code})` !== name)
            this.setState({ selected: newSelected })
            this.handleChange(newSelected)
          }
        }
        selectedElements[i].onclick = removeItemOnClick
      }
    }
  }

  componentWillUnmount() {
    const selectedElements = document.querySelectorAll('.rbt-token-removeable')
    if (selectedElements.length) {
      selectedElements.forEach(element => {
        element.onclick = undefined
      })
    }
  }

  loadOptions() {
    if (this.state.regionsDataByCountry) {
      let regionsDataByCountry = this.state.regionsDataByCountry
      let sortedCountryCodes = RegionTools.getSortedCountryCodesByCountryName({ regionsDataByCountry })
      let processedData = []
      for (let i = 0; i < sortedCountryCodes.length; i++) {
        let actualCountryData = regionsDataByCountry[sortedCountryCodes[i]]
        actualCountryData.regions = RegionTools.getSortedRegionsByRegionName({ regionsData: actualCountryData.regions })

        let processedCountry = {
          countryCode: sortedCountryCodes[i],
          countryFullName: actualCountryData.countryFullName,
          code: sortedCountryCodes[i],
          name: actualCountryData.countryFullName,
          isCountry: true
        }
        processedData.push(processedCountry)
        actualCountryData.regions.forEach(region => {
          let processedRegion = region
          processedRegion.countryCode = sortedCountryCodes[i]
          processedRegion.countryFullName = actualCountryData.countryFullName
          processedRegion.isCountry = false
          processedData.push(processedRegion)
        })
      }
      return processedData
    }
    return []
  }

  renderMenuItemChildren(option, props, index) {
    if (option.isCountry) {
      return (
        <div>
          <strong>{option.name}</strong>
        </div>
      )
    } else {
      return <div>{`${option.name} (${option.code})`}</div>
    }
  }

  handleChange(selected) {
    selected = this.handleMultiple(selected)

    let selectedPlaces = []
    let regionsDataByCountry = this.state.regionsDataByCountry

    selected.forEach(item => {
      if (item.isCountry) {
        let country = {}
        country.isCountry = true
        country.countryFullName = regionsDataByCountry[item.countryCode].countryFullName
        country.regionsData = regionsDataByCountry[item.countryCode].regions
        country.regionId = regionsDataByCountry[item.countryCode].countryId;
        selectedPlaces.push(country)
      } else {
        let region = {}
        region.isCountry = false
        region.regionsData = [item]
        region.regionId = item.id;
        selectedPlaces.push(region)
      }
    })
    this.props.fn(selectedPlaces)
    this.setState({ selected })
  }

  handleMultiple(selected) {
    if (!this.props.multiple) {
      if (selected.length > 1) {
        selected.shift()
      }
    }
    return selected
  }

  render() {
    let placeholder
    if (this.props.multiple) {
      placeholder = this.formatMessage(messages.placeholder2)
    } else {
      placeholder = this.formatMessage(messages.placeholder)
    }
    return (
      <Typeahead
        ref={this.typeAhead}
        selected={this.state.selected}
        multiple={true}
        onChange={selected => this.handleChange(selected)}
        options={this.loadOptions()}
        labelKey={option => `${option.name} (${option.code})`}
        filterBy={['countryFullName', 'code']}
        renderMenuItemChildren={this.renderMenuItemChildren}
        selectHintOnEnter={true}
        placeholder={placeholder}
      />
    )
  }
}

export default injectIntl(TypeAheadFilter)



// WEBPACK FOOTER //
// ./src/modules/Filters/TypeAheadFilter/TypeAheadFilter.jsx